import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
})
export class TruncatePipe implements PipeTransform {
  constructor() {}

  transform(v: string, length: number): string {
    return v
      ? v.length > length
        ? v.slice(0, length).concat('...')
        : v
      : '';
  }
}
